@let data = model();
@let columnData = column();

@switch (columnData.key) {
  @case (getColumnKey('totalPrice')) {
    @if (isNil(data.refundSummary)) {
      <app-currency [amount]="data.totalPrice" />
    } @else {
      <app-refunded-price
        [currentPrice]="data.refundSummary.currentPrice"
        [refundedPrice]="data.refundSummary.refundedPrice"
        [originalPrice]="data.refundSummary.originalPrice" />
    }
  }
  @case (getColumnKey('number')) {
    <app-router-link
      [route]="Route.PL_AccountOrderDetails"
      [params]="detailsParams()">
      <div
        pTooltip="Kliknij, aby wyświetlić szczegóły"
        class="text-[#3858E9] underline decoration-dotted">
        {{ data.number }}
      </div>
    </app-router-link>
  }
  @case (getColumnKey('status')) {
    <app-order-status [status]="data.status" />
  }
  @default {
    <app-table-body-no-reference-cell [columnKey]="columnData.key" />
  }
}
